import { Box, Typography } from "@mui/material";
import { TEXT } from "../../../constants/text";
// svg
import { ReactComponent as IconInformation } from "../../../assets/svg/information.svg";


export const AccessTab = ({ selectedLine }) => {
  const selectedLineNum = selectedLine
    ? selectedLine.properties.lineName
    : null;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "16px",
        pt: "6px",
      }}
    >
      <Typography sx={{ fontSize: "24px", mb: '24px'}}>{TEXT.siteSettings.accessTitle}</Typography>
      <Box>
        <Typography
          sx={{ fontSize: "12px", color: "#343745", m: "0 0 4px 8px", fontWeight: 500 }}
        >
          Entry & Exit Side
        </Typography>
        <Box
          sx={{
            background: "#EBEBEC",
            borderRadius: "8px",
            border: "1px solid #DBDBEB",
            padding: "8px",
            width: "100%",
          }}
        >
          <Typography sx={{ fontSize: "14px", color: selectedLineNum ? '#343745' : "#A2A3A9" }}>
            {selectedLineNum ? selectedLineNum.toUpperCase() : "Select line"}{" "}
          </Typography>
          <Box />
        </Box>
        <Box sx={{ display: "flex", mt: "16px" }}>
          <Box>
            <IconInformation fill="#5D5F6A" width="24px" height="24px" />
          </Box>

          <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
          {TEXT.siteSettings.accessTooltip}
          </Typography>
        </Box>

      </Box>
    </Box>
  );
};
